<template>
  <div class="page-wrap">
    <oHead :white="true"></oHead>
    <animationWrap @current="(newV)=>{this.currentModule = newV}">
      <div class="banner-slot">
        <Transition enter-active-class="animate__animated animate__slideInDown">
          <div class="banner" v-if="currentModule>0">
            <div>万福信息为生态治理赋能</div>
            <p>
              <span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>
            </p>
          </div>
        </Transition>
      </div>
      <moduleWrap
        class="aboutwf-wrap"
        :active="currentModule>0"
        bgCol="#f7fafc"
        :titleV="false"
        :subTitleV="false"
      >
        <div class="aboutwf-slot">
          <Transition enter-active-class="animate__animated animate__fadeInUpBig">
            <div class="aboutwf-inner" v-if="currentModule>0">
              <div class="aboutwf-num">
                <div class="about-item" v-for="(item,ind) in aboutUsData.aboutNum" :key="ind">
                  <div class="num">{{(item.num).toFixed(0)}}</div>
                  <div class="about-title">{{item.title}}</div>
                </div>
              </div>
              <div class="title">关于万福</div>
              <div class="content">
                <div class="aboutwf-video" @click="play">
                  <div class="play-icon" v-show="!playing" @click.stop="play"></div>
                  <!-- controls -->
                  <video width="100%" :controls="playing" height="100%" ref="video">
                    <source :src="aboutUsData.videoUrl" type="video/mp4" />您的浏览器不支持Video标签。
                  </video>
                </div>
                <div class="aboutwf-intro" v-html="aboutUsData.intro"></div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <div class="milepost-wrap column-wrap">
        <div class="milepost-inner">
          <Transition enter-active-class="animate__animated animate__bounceInUp">
            <div class="milepost-title" v-if="currentModule > 1">万福里程碑</div>
          </Transition>
          <Transition enter-active-class="animate__animated animate__bounceInDown">
            <div class="milepost-swiper" v-if="currentModule > 1">
              <swiper :options="milepostOption" @mouseenter.native="swiperEnter('milepostSwiper')" @mouseleave.native="swiperLeave('milepostSwiper')" ref="milepostSwiper">
                <swiper-slide class="milepost-item" v-for="(item,ind) of milepostData" :key="ind">
                  <div class="content">
                    <div class="date">{{item.date}}</div>
                    <div class="desc">{{item.content}}</div>
                  </div>
                </swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <div class="swiper-button-prev page-btn" slot="button-prev"></div>
                <div class="swiper-button-next page-btn" slot="button-next"></div>
              </swiper>
            </div>
          </Transition>
        </div>
      </div>
      <moduleWrap
        class="authentication-wrap"
        :active="currentModule>2"
        bgCol="#f7fafc"
        title="我们获得的权威认证"
        :subTitleV="false"
      >
        <div class="authentication-slot">
          <Transition enter-active-class="animate__animated animate__fadeInUpBig">
            <div class="authen-inner" v-if="currentModule>2">
              <ul>
                <li
                  :class="{active: authIndex == ind}"
                  @mouseleave.stop="tabLeave"
                  @mouseenter.stop="authEnter(ind)"
                  v-for="(item,ind) in authenticationData"
                  :key="ind"
                >{{item.name}}</li>
                <li class="line" :style="{left: 200 + authIndex*400 - 40 +'px'}"></li>
              </ul>
              <swiper class="authen-child" @mouseenter.native="swiperEnter('authenSwiper')" @mouseleave.native="swiperLeave('authenSwiper')" :options="authenOption" ref="authenSwiper">
                <swiper-slide
                  class="authen-item"
                  v-for="(child,index) in authenticationData[authIndex].children"
                  :key="index"
                >
                  <div class="authen-img" :style="{height:child.name?'calc(100% - 45px)':'100%'}">
                    <img :src="child.imgUrl" @click="showPreview(authenticationData[authIndex].children,index)" alt />
                  </div>
                  <div class="authen-name" v-if="child.name">{{child.name}}</div>
                </swiper-slide>
              </swiper>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        class="partner-wrap"
        :active="currentModule>3"
        bgCol="#fff"
        title="我们的合作伙伴"
        :subTitleV="false"
      >
        <div class="partner-slot">
          <Transition enter-active-class="animate__animated animate__rubberBand">
            <div class="partner-inner" v-if="currentModule>3">
              <div
                class="partner-item"
                :style="{backgroundImage: `url(${item.imgUrl})`,width: `${280*(item.col || 1)}px`}"
                v-for="(item,ind) in partnerData"
                :key="ind"
              ></div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        class="demeanor-wrap"
        :active="currentModule>4"
        bgCol="#f7fafc"
        title="人文风采"
        :subTitleV="false"
      >
        <div class="demeanor-slot">
          <Transition enter-active-class="animate__animated animate__tada">
            <swiper
              class="demeanor-inner"
              v-if="currentModule>4"
              :options="demeanorOption"
               @mouseenter.native="swiperEnter('demeanorSwiper')" @mouseleave.native="swiperLeave('demeanorSwiper')"
              ref="demeanorSwiper"
            >
              <swiper-slide
                class="demeanor-item"
                v-for="(item,ind) of demeanorData"
                @click.native="showPreview(demeanorData,ind)"
                :style="{backgroundImage: `url(${item.imgUrl})`}"
                :key="ind"
              ></swiper-slide>
            </swiper>
          </Transition>
        </div>
      </moduleWrap>
      <oFoot :active="currentModule>5"></oFoot>
    </animationWrap>
    <imagePreview v-if="isOpenPreview" :imgsList="imgsList" :pindex="pindex" :isOpen="isOpenPreview" @closeLayer="isOpenPreview = false" />
  </div>
</template>

<script>
import consulting from '@/components/consulting.vue'
import moduleWrap from '@/components/moduleWrap.vue'
import imagePreview from '@/components/imagePreview.vue'
import oHead from '@/components/header.vue'
import oFoot from '@/components/footer.vue'
import gsap from 'gsap'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import animationWrap from '@/components/animationWrap.vue'
import { swiperEnter,swiperLeave,tabLeave } from '@/util.js'

export default {
  components: {
    oHead,
    swiper,
    swiperSlide,
    moduleWrap,
    imagePreview,
    consulting,
    oFoot,
    animationWrap
  },
  data() {
    return {
      isOpenPreview: false,
      imgsList: [],
      pindex: 0,
      milepostOption: {
        // pagination: '.swiper-pagination',
        initialSlide: 0, //默认第几张
        slidesPerView: 3,
        simulateTouch: true,
        speed: 1000, //滑动速度
        autoplay: 3000,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
      demeanorOption: {
        slidesPerView: 4.2,
        spaceBetween: 24,
        autoplayDisableOnInteraction: false, //触摸后再次自动轮播
        autoplay: 1, //每张播放时长3秒，自动播放
        speed: 3000, //滑动速
      },
      milepostData: [
        {
          date: '2024.1',
          content: '万福信息承建项目“德阳市大气治理信息化监管平台”荣获2023年度德阳智慧城市十佳案例奖',
        },
        {
          date: '2024.1',
          content: '万福信息荣获2023年度福建省唯一数字乡村优秀案例奖',
        },
        {
          date: '2024.1',
          content: 'IDC创新者万福信息中选2024年海洋垃圾算法服务',
        },
        {
          date: '2023.12',
          content: '万福信息荣获“软件企业”认定证书',
        },
        {
          date: '2023.11',
          content: '万福信息受邀参加第四届湖南省水利先进实用技术（产品）推介会',
        },
        {
          date: '2023.11',
          content: '万福信息“水利一杆通”入选《湖南省2023年度水利先进实用技术（产品）推广目录》',
        },
        {
          date: '2023.9',
          content: '入海排污口系统在“福建省海洋生态环境管理培训及入海排污口整治现场推进会”上发布',
        },
        {
          date: '2023.7',
          content: '深度服务于泉州、莆田、漳州等市防御台风“杜苏芮”工作，得到省、市领导的表彰和好评',
        },
        {
          date: '2023.7',
          content: '智慧水库、水利一杆通、遥测终端等产品入选2023年度《全国水利系统招标产品重点采购目录》',
        },
        {
          date: '2023.6',
          content: '受邀参加“2023年长沙市新型智慧城市智慧环保专题沙龙”',
        },
        {
          date: '2023.5',
          content: '入选2023年度全省数字经济核心产业领域创新企业“瞪羚”名单',
        },
        {
          date: '2023.4',
          content: '受邀参加2023中国水利信息化技术论坛',
        },
        {
          date: '2023.4',
          content: '漳浦县建设案例获学习强国报道',
        },
        {
          date: '2023.2',
          content: '受邀参加2022中国水利学术大会·智慧水利数字孪生分会',
        },

        {
          date: '2022.12',
          content: '场景化AI素材库突破百万张',
        },
        {
          date: '2022.11',
          content: '中标签约多个智慧水利项目',
        },
        {
          date: '2022.10',
          content: 'VIMS视频智能管理系统通过公安部检测',
        },
        {
          date: '2022.09',
          content: '获得首个发明专利授权',
        },
        {
          date: '2022.09',
          content: '参与水利视频 AI 示范应用联合实验室',
        },
        {
          date: '2022.08',
          content: '万福AIoT智能引擎（VUE）上线',
        },
        {
          date: '2022.07',
          content: '首创城市级视频标签治理体系',
        },
        {
          date: '2022.06',
          content: '入选福建省科技小巨人企业',
        },
        {
          date: '2022.05',
          content: '首款边缘计算产品EAI智算精灵正式发布并实现批量销售',
        },
        {
          date: '2022.02',
          content: '加入福建省幸福河湖促进会',
        },
        {
          date: '2021.12',
          content: '生态环境视图数据集样本突破10万张',
        },
        {
          date: '2021.11',
          content: '行业物联网平台UMIoT元物联平台上线',
        },
        {
          date: '2021.08',
          content: 'EVIAS视频智能分析系统上线，构建大小模型协同进化体系',
        },
        {
          date: '2021.05',
          content: '首创“小场景”人工智能模型，并在福建省海漂垃圾综合治理中应用',
        },
        {
          date: '2021.03',
          content: 'VIMS视频智能管理系统上线',
        },
        {
          date: '2021.01',
          content: '南威软件（股票代码：603636）战略投资',
        },
      ],
      currentModule: 0,
      playing: false,
      aboutUsData: {
        aboutNum: [
          {
            num: 38,
            title: '知识产权',
          },
          {
            num: 14,
            title: '商标',
          },
          {
            num: 375,
            title: '建立合作关系',
          },
        ],
        videoUrl:
          '/img/wfvideo.mp4',
        intro:
          '<p>福建万福信息技术有限公司（以下简称“万福信息”）成立于2017年，公司总部位于福州市高新区万福中心。万福信息致力于环保、水利等行业的数字化转型和提升，2021年1月获南威软件（股票代码：603636）战略投资。万福信息以AI行业应用为锚点，以环保、水利业务场景为驱动，力求贴近、再贴近客户需求，构建AI体系化、场景化能力，实现技术和业务的有机融合。</p><p>万福信息聚焦水环境、水工程、水资源和企业环保3+1应用场景，围绕视觉AI，构建3大平台能力——通过VIMS视频智能管理系统、UMIoT元物联平台和EAIGo视频智能分析系统，打造万福AIoT智能运行引擎（VUE)，以数据为驱动，打造环境智能感知→态势智能分析→事件智能发现→智能预案处置→智能协同指挥→智能评价评估的数智能力，赋能环保水利，建设智能化“一网统管”。万福信息在福建、海南、湖南、四川、重庆等省份打造了环保、水利智慧化监管应用案例，参与了福建省生态云、泉州市水资源综合调度平台、海南省定安县城乡污水治理项目等综合性项目建设。</p><p>在海量数据汇聚的时代，万福信息将充分发挥自身技术力量，运用科技手段为行业赋能，打造“智慧之眼”，助力数字中国建设！	</p>',
      },
      partnerData: [
        {
          imgUrl: '/img/aboutUs/logo01@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo02@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo03@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo04@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo05@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo06@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo07@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo08@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo09@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo10@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo11@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo12@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo13@2x.png',
          col: 2,
        },
        {
          imgUrl: '/img/aboutUs/logo14@2x.png',
          col: 2,
        },
        {
          imgUrl: '/img/aboutUs/logo15@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo16@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo17@2x.png',
        },
        {
          imgUrl: '/img/aboutUs/logo18@2x.png',
        },
      ],
      demeanorData: [
        {
          imgUrl: '/img/aboutUs/22557470.png',
        },
        {
          imgUrl: '/img/aboutUs/22557469.png',
        },
        {
          imgUrl: '/img/aboutUs/22557468.png',
        },
        {
          imgUrl: '/img/aboutUs/22557467.png',
        },
        {
          imgUrl: '/img/aboutUs/22557466.png',
        },
        {
          imgUrl: '/img/aboutUs/22557453.png',
        },
        {
          imgUrl: '/img/aboutUs/22557454.png',
        },
        {
          imgUrl: '/img/aboutUs/22557455.png',
        },
        {
          imgUrl: '/img/aboutUs/22557456.png',
        },
        {
          imgUrl: '/img/aboutUs/22557457.png',
        },
        {
          imgUrl: '/img/aboutUs/22557458.png',
        },
        {
          imgUrl: '/img/aboutUs/22557459.png',
        },
        {
          imgUrl: '/img/aboutUs/22557460.png',
        },
        {
          imgUrl: '/img/aboutUs/22557461.png',
        },
        {
          imgUrl: '/img/aboutUs/22557462.png',
        },
        {
          imgUrl: '/img/aboutUs/22557463.png',
        },
        {
          imgUrl: '/img/aboutUs/22557464.png',
        },
        {
          imgUrl: '/img/aboutUs/22557465.png',
        },
      ],
      authIndex: 0,
      authenOption: {
        slidesPerView: 4.2,
        spaceBetween: 24,
        autoplay: 3000, //每张播放时长3秒，自动播放
        speed: 2000, //滑动速
      },
      authenticationData: [
        {
          name: '公司相关证书',
          children: [
            {
              name: '安防工程企业',
              imgUrl: '/img/auth/22565204.png',
            },
            {
              name: '安全生产许可证',
              imgUrl: '/img/auth/22565205.png',
            },
            {
              name: '高新技术企业',
              imgUrl: '/img/auth/22565206.png',
            },
            {
              name: '高新技术企业培育证书',
              imgUrl: '/img/auth/22565207.png',
            },
            {
              name: '环境管理体系-年度确认证书',
              imgUrl: '/img/auth/22565208.png',
            },
            {
              name: '环境管理体系认证证书',
              imgUrl: '/img/auth/22565209.png',
            },
            {
              name: '建筑业企业资质证书-副本',
              imgUrl: '/img/auth/22565210.png',
            },
            {
              name: '建筑业企业资质证书-正本',
              imgUrl: '/img/auth/22565211.png',
            },
            {
              name: '科技型中小企业',
              imgUrl: '/img/auth/22565212.png',
            },
            {
              name: '企业信用等级证书',
              imgUrl: '/img/auth/22565213.png',
            },
            {
              name: '软件产品证书',
              imgUrl: '/img/auth/22565214.png',
            },
            {
              name: '软件产品证书',
              imgUrl: '/img/auth/22565215.png',
            },
            {
              name: '信息安全管理体系-年度确认证书',
              imgUrl: '/img/auth/22565216.png',
            },
            {
              name: '信息安全管理体系认证证书',
              imgUrl: '/img/auth/22565217.png',
            },
            {
              name: '营业执照',
              imgUrl: '/img/auth/22565218.png',
            },
            {
              name: '职业健康安全管理体系-年度确认证书',
              imgUrl: '/img/auth/22565219.png',
            },
            {
              name: '职业健康安全管理体系认证证书',
              imgUrl: '/img/auth/22565220.png',
            },
            {
              name: '质量管理体系-年度确认证书',
              imgUrl: '/img/auth/22565221.png',
            },
            {
              name: '质量管理体系认证证书',
              imgUrl: '/img/auth/22565222.png',
            },
          ],
        },
        {
          name: '软件著作证书',
          children: [
            {
              name: '',
              imgUrl: '/img/auth/22335960.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335961.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335962.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335963.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335964.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335965.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335966.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335967.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335968.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335969.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335970.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335971.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335972.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335973.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335974.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335975.png',
            },
          ],
        },
        {
          name: '产品认证证书',
          children: [
            {
              name: '',
              imgUrl: '/img/auth/22335925.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335926.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335927.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335929.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335930.png',
            },
            {
              name: '',
              imgUrl: '/img/auth/22335931.png',
            }
          ],
        },
      ],
    }
  },
  watch: {
    currentModule(newV) {
      if (newV == 1) {
        setTimeout(() => {
          this.aboutUsData.aboutNum.map((item, ind) => {
            this.animationNum(ind)
          })
        }, 650)
      }
    },
  },
  created() {
    this.resize()
    this.$nextTick(()=>{
      this.play()
    })
  },
  methods: {
    swiperEnter,
    swiperLeave,
    tabLeave,
    showPreview(arr,ind){
      // 获取图片目录
      let lastI = arr[ind].imgUrl.lastIndexOf('/')
      let catalogue = arr[ind].imgUrl.slice(0,lastI)
      arr.map(item=>{
        // 图片同级目录big文件夹存放大图
        item.bigImg = item.imgUrl.replace(catalogue,catalogue+'/big')
      })
      this.imgsList = JSON.parse(JSON.stringify(arr))
      this.pindex = ind
      this.isOpenPreview = true
    },
    animationNum(ind) {
      let num = this.aboutUsData.aboutNum[ind].num
      this.aboutUsData.aboutNum[ind].num = 0
      gsap.to(this.aboutUsData.aboutNum[ind], {
        duration: 1.5,
        num: Number(num) || 0,
      })
    },
    authEnter(index){
      if (this.authIndex == index) return
      if (this.timer) clearTimeout(this.timer)
      this.tabEnterTime = new Date().getTime()
      this.timer = setTimeout(() => {
        this.$refs.authenSwiper.swiper.slideTo(0)
        this.authIndex = index
        const tl2 = gsap.timeline()
        this.$nextTick(()=>{
          tl2.staggerFromTo(
            '.authen-item',
            0.3,
            {
              opacity: 0,
              x: 300,
              ease: 'back.in(1.7)',
            },
            {
              opacity: 1,
              x: 0,
              ease: 'back.in(1.7)',
            },
            0.2,
            '+=0'
          )
        })
      }, 350);
    },
    resize() {
      let windowWidth = window.innerWidth
      this.milepostOption.slidesPerView = windowWidth / 288
    },
    play() {
      if (this.playing) {
        this.playing = false
        this.$refs.video.pause()
      } else {
        this.playing = true
        this.$refs.video.play()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.banner-slot {
  width: 100%;
  height: 328px;
  background-image: url('../../public/img/aboutUs/banner05@2x.png');
  @include bgConfig;
}
.banner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & > div {
    font-weight: bold;
    font-size: 40px;
    color: #333333;
  }
  p {
    margin-top: 16px;
    span {
      font-size: 16px;
      margin-right: 10px;
      color: #929caa; 
    }
  }
}
.aboutwf-wrap {
  padding: 0 0 40px;
  min-height: 664px;
  .aboutwf-slot {
    width: 100%;
    color: #666666;
    .aboutwf-inner {
      position: relative;
      top: -40px;
      z-index: 9;
      .aboutwf-num {
        display: flex;
        justify-content: space-around;
        text-align: center;
        align-items: center;
        width: 100%;
        height: 166px;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 4px 25px 0px rgba(216, 222, 228, 0.5);
        .about-item {
          width: 200px;
          .num {
            font-weight: bold;
            font-size: 48px;
            color: #0b68bf;
            margin-bottom: 12px;
          }
          .about-title {
            font-size: 24px;
            color: #666666;
          }
        }
      }
      .title {
        color: #333;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        margin: 80px 0 48px;
      }
      .content {
        display: flex;
        justify-content: space-between;
        ::-webkit-scrollbar{
          width: 5px;
          height: 5px;
        }
        .aboutwf-video {
          position: relative;
          width: 480px;
          height: 288px;
          background: #000;
          .play-icon {
            position: absolute;
            z-index: 10;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 94px;
            height: 94px;
            @include bgConfig;
            background-size: 100% 100%;
            cursor: pointer;
            transition: all 0.3s ease-out;
            background-image: url('../../public/img/aboutUs/icon_play@2x.png');
            &:hover {
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
        .aboutwf-intro {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          width: 672px;
          font-size: 16px;
          padding-right: 5px;
          line-height: 36px;
          height: 288px;
          text-align: justify;
          overflow-y: scroll;
          text-indent: 2em;
        }
      }
    }
  }
}
.milepost-wrap {
  background: #fff;
  min-height: 452px;
  overflow: hidden;
  .milepost-inner {
    padding: 63px 0 80px;
    width: 100%;
    .milepost-title {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 67px;
      text-align: center;
    }
    .milepost-swiper {
      width: 100%;
      .page-btn {
        width: 48px;
        height: 48px;
        background-image: url('../../public/img/aboutUs/icon_arrow_sel@2x.png');
        background-size: 100% 100%;
        &.swiper-button-next {
          transform: rotate(180deg);
          right: 40px;
        }
        &.swiper-button-prev {
          left: 40px;
        }
        &.swiper-button-disabled {
          background-image: url('../../public/img/aboutUs/icon_arrow_nor@2x.png');
          &.swiper-button-prev {
            transform: rotate(180deg);
          }
          &.swiper-button-next {
            transform: rotate(0deg);
          }
        }
      }

      .milepost-item {
        width: 288px;
        height: 200px;
        padding: 0 32px;
        border-right: 1px solid rgba($color: #929caa, $alpha: 0.3);
        &:last-child {
          border-right: none;
        }
        .date {
          font-weight: bold;
          font-size: 32px;
        }
        .desc {
          margin-top: 26px;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
.authentication-wrap {
  min-height: 614px;
  .authentication-slot {
    width: 100%;
  }
  .authen-inner {
    margin-top: 48px;
    ul {
      display: flex;
      height: 50px;
      position: relative;
      border-bottom: 1px solid rgba($color: #929caa, $alpha: 0.4);
      li {
        cursor: pointer;
        text-align: center;
        font-size: 18px;
        width: 400px;
        padding-bottom: 24px;
        &.line {
          position: absolute;
          bottom: 0;
          width: 72px;
          height: 3px;
          padding: 0;
          transition: all 0.3s linear;
          background: #0b68bf;
        }
        &.active {
          font-weight: bold;
          color: #0b68bf;
        }
      }
    }
    .authen-child {
      display: flex;
      padding-top: 40px;
      .authen-item {
        padding: 16px;
        width: 282px;
        height: 274px;
        background: #fff;
        border-radius: 4px;
        transition: all .3s linear;
        box-shadow: 0px 4px 25px 0px rgba(216, 222, 228, 0.5);
        .authen-img {
          background: #f5f6f7;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
          img {
            max-height: 100%;
            max-width: 100%;
          }
        }
        .authen-name {
          font-size: 16px;
          width: 100%;
          margin-top: 22px;
          @include text-ellipsis-line(1);
          text-align: center;
        }
      }
    }
  }
}
.partner-wrap {
  padding-top: 63px;
  min-height: 689px;
  .partner-inner {
    padding-top: 48px;
    display: flex;
    flex-wrap: wrap;
    .partner-item {
      height: 112px;
      margin-right: 26px;
      margin-bottom: 40px;
      @include bgConfig;
      background-size: 100% 100%;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
.demeanor-wrap {
  min-height: 453px;
  .demeanor-slot {
    width: 100%;
    padding-top: 48px;
    .demeanor-inner {
      height: 200px;
      .demeanor-item {
        @include bgConfig;
        background-size: 100% 100%;
      }
    }
  }
}
</style>